module.exports = __webpack_public_path__ + "static/media/big-gallery-3.34c6010a.jpg";